// extracted by mini-css-extract-plugin
module.exports = {"avatar":"asg_my"};